export default __webpack_public_path__ + "static/media/bonding-curve.6d39c549.svg";